<mat-form-field>
  <mat-label [translate]="labelTranslateKey"> </mat-label>
  <mat-select [formControl]="control" [multiple]="multiSelect">
    @if (!groupedOptions$) {
      @for (option of options$ | async; track option[valueProperty]) {
        <mat-option [value]="option[valueProperty]" (onSelectionChange)="emitSelectedOption($event, option)">
          {{ option[displayProperty] | translate }}
        </mat-option>
      }
    }

    @if (groupedOptions$) {
      @for (option of groupedOptions$ | async; track option.groupName) {
        @if (option.options.length > 0) {
          <mat-optgroup [label]="option.groupName | translate">
            @for (innerOption of option.options; track innerOption[valueProperty]) {
              <mat-option
                [value]="innerOption[valueProperty]"
                (onSelectionChange)="emitSelectedOption($event, innerOption)"
              >
                {{ innerOption[displayProperty] | translate }}
              </mat-option>
            }
          </mat-optgroup>
        }
      }
    }
  </mat-select>
  @if (!!control?.hasError('required')) {
    <mat-error translate="FORMS.ERROR.FIELD_REQUIRED"></mat-error>
  }
  @if (hintTranslateKey) {
    <mat-hint [translate]="hintTranslateKey"></mat-hint>
  }
  @if (hintTemplate) {
    <mat-hint><ng-content select="[hint]"> </ng-content></mat-hint>
  }
</mat-form-field>
